// extracted by mini-css-extract-plugin
module.exports = {"root":"MyLocation_root__2Kb4r","icon":"MyLocation_icon__cubWL"};